import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import TagsInput from 'react-tagsinput'
import { ReactSession } from 'react-client-session';
import { ToastContainer, toast } from 'react-toastify';
import {Helmet} from "react-helmet";
import 'react-toastify/dist/ReactToastify.css';

import '../Dashboard.css';
import classes from "./EditVideo.module.css";
import styles from '../Dashboard.module.css';
import 'react-tagsinput/react-tagsinput.css'

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

import noThumb from "../../../images/no-thumb.jpg";

function EditVideo() {
    const  { vid } = useParams();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [video, setVideo] = useState([]);
    const [tags, setTags] = React.useState([]);
    const [nsfw, setNsfw] = useState(true);
    const [privacy, setPrivacy] = useState(true);
    // const [description, setDescription] = useState('');
    const [image, setImage] = useState(null);
    const [thumb, setThumb] = useState(null);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    const handleChange = (tags) => {
        setTags(tags);

        reset({
            'tags': tags.toString()
        });
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/video.php?uid=${logged_user}&vid=${vid}`)
            .then(response => {
                setVideo(response.data);
                setTags(response.data.tags);
                setImage(response.data.thumb);
                response.data.nsfw === '0' ? setNsfw(true) : setNsfw(false);
                response.data.private === '0' ? setPrivacy(true) : setPrivacy(false);
            })
            .catch(err => {
                console.log(err);
            })
    }, [vid]);
        

    useEffect(() => {
        reset({
            'title': video.title,
            'description': video.description,
            'tags': tags.toString(),
            'duration': video.duration || 0
        });
    }, [video]);

    const handleNsfw = (e) => {
        if(e.target.value === '1') {
            setNsfw(false);
        } else {
            setNsfw(true);
        }
    }

    const handlePrivacy = (e) => {
        if(e.target.value === '1') {
            setPrivacy(false);
        } else {
            setPrivacy(true);
        }
    }

    const onSubmit = (e) => {
        const toast_id = toast.loading("Please wait...");

        var data = new FormData();
        data.append('uid', logged_user);
        data.append('edited-video', vid);
        data.append('title', e.title);
        data.append('description', e.description);
        data.append('duration', e.duration);
        data.append('categ', e.categ);
        data.append('tags', e.tags);
        data.append('nsfw', e.nsfw);
        data.append('priv', e.priv);
        data.append('play-img', thumb);

        // let formObject = Object.fromEntries(data.entries());
        // console.log(formObject);

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/update_video.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(response => {
                console.log(response.data);
                toast.update(toast_id, {render: response.data.message, autoClose: 5000, type: response.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
    }

    const onImageChange = (e) => {
        setThumb(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setImage(video.thumb);
        }
    }

    return (
        <>
            <Helmet>
                <title>Edit Video</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                            <div className={styles.card}>
                                <div className="card-body">
                                    <div className={classes.form_wrap}>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="row">
                                                <div className="col-8">
                                                        <div className="form-group">
                                                            <label>Title:</label>
                                                            <input {...register('title', {required: true})}  className="form-control" type="text" />
                                                            {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Description</label>
                                                            <textarea {...register('description', {required: true})} className="form-control" rows="3"></textarea>
                                                            {errors.description && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Duration (in seconds)</label>
                                                            <input {...register('duration')}  className="form-control"  type="number" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Category</label>
                                                            <select {...register('categ')} className="form-control">
                                                                <optgroup label="Categories" dangerouslySetInnerHTML={{__html: `${video.cats}`}} />
                                                            </select>
                                                            {/* <Markup content={video.cats} />
                                                            {video.cats}
                                                            <p>{[video.cats]}</p> */}
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Tags</label>
                                                            <TagsInput value={tags} onChange={handleChange} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>NSFW</label>
                                                            <div className={`form-group ${classes.radio}`}>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('nsfw')} type="radio" className="styled" value="1" checked={!nsfw} onClick={handleNsfw}  /> <span>Not safe</span>
                                                                </label>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('nsfw')} type="radio" className="styled" value="0" checked={nsfw} onClick={handleNsfw} /> <span>Safe</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Privacy</label>
                                                            <div className={`form-group ${classes.radio}`}>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('priv')} type="radio" className="styled" value="1" checked={!privacy} onClick={handlePrivacy} /> <span>Private</span>
                                                                </label>
                                                                <label className="radio d-inline-flex">
                                                                    <input {...register('priv')} type="radio" className="styled" value="0" checked={privacy} onClick={handlePrivacy} /> <span>Public</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <input type="hidden" {...register('edited-video')} value={video.id} />
                                                        <input type="hidden" {...register('tags')} />
                                                        <div className="form-group mb-0">
                                                            <button className="btn btn-primary" type="submit">Save</button>
                                                        </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className={`${classes.video_thumb} mt-4 pt-2 mb-3`}>
                                                        <img src={image} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label> Video Thumbnails(350px X 250px)</label>
                                                        <input {...register('play-img')} onChange={onImageChange}  className="form-control" type="file" />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditVideo;